import React, { createContext, useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import fileSize from 'filesize';
import { toast } from 'react-toastify';
import pdfMake from 'pdfmake';
import {
  Box,
  Button,
  Paper,
  Stack,
  Stepper,
  Step,
  StepLabel
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useHistory, Link } from 'react-router-dom';
import Toast from '../../components/Toast';
import { Header } from '../../components/Header';
import { ModalLoading } from '../../components/ModalLoading';
import { CollectData } from './components/CollectData';
import { RequesterData } from './components/RequesterData';
import { RecipientData } from './components/RecipientData';
import { LoadData } from './components/LoadData';
import { TaxInfo } from './components/TaxInfo';
import { ModalPreCollection } from './components/ModalPreCollection';
import { ModalInvoiceIssued } from './components/ModalInvoiceIssued';
import { ModalWishImportInvoice } from './components/ModalWishImportInvoice';
import { ModalChangeCollectAddress } from './components/ModalChangeCollectAddress';
import { ModalAddCollectAddress } from './components/ModalAddCollectAddress';
import { ModalAcceptTransportTerms } from './components/ModalAcceptTransportTerms';
import { ModalReceiveCollectInfo } from './components/ModalReceiveCollectInfo';
import { ModalCreateDeclaration } from './components/ModalCreateDeclaration';
import { ModalRemoveDeclaration } from './components/ModalRemoveDeclaration';
import { ModalRemoveInvoice } from './components/ModalRemoveInvoice';
import { ModalRemoveFile } from './components/ModalRemoveFile';
import { ModalAcceptInvoiceNotIssued } from './components/ModalAcceptInvoiceNotIssued';
import { ModalAcceptResponsibilityTerms } from './components/ModalAcceptResponsibilityTerms';
import { ModalCollectCreated } from './components/ModalCollectCreated';
import { ModalFinancialRestriction } from './components/ModalFinancialRestriction';
import { useAuth } from '../../hooks/Auth';
import { useIntegration } from '../../hooks/Integration';
import { useManager } from '../../hooks/Manager';
import { useModal } from '../../hooks/Modal';
import { usePickup } from '../../hooks/Pickup';
import { useStorage } from '../../hooks/Storage';
import { useWorkflow } from '../../hooks/Workflow';
import { parseCpfCnpj, parsePhone } from '../../helpers/parseValues';
import { options } from '../../helpers/toastOptions';
import { Container, Content, Route, TitlePage } from './styled';

import { contentDeclaration } from '../../reports/contentDeclaration';

export const DefaultCollectContext = createContext({});

const DefaultCollect = () => {
  const [steps, setSteps] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [transportTypeList, setTransportTypeList] = useState([]);
  const [transportSelectedToModal, setTransportSelectedToModal] = useState('');
  const [freightTypeList, setFreightTypeList] = useState([]);
  const [materialTypeList, setMaterialTypeList] = useState([]);
  const [otherMaterialId, setOtherMaterialId] = useState('');
  const [checkListSelected, setCheckListSelected] = useState({});
  const [requester, setRequester] = useState('');
  const [requesterContact, setRequesterContact] = useState({
    contactName: '',
    contactEmail: '',
    phoneNumber: '',
    extension: ''
  });
  const [hasVariousDestinations, setHasVariousDestinations] = useState(false);
  const [destinationQuantity, setDestinationQuantity] = useState('');
  const [collectRequesterData, setCollectRequesterData] = useState({});
  const [collectSenderData, setCollectSenderData] = useState({});
  const [collectRecipientData, setCollectRecipientData] = useState({});
  const [disabledRecipientData, setDisabledRecipientData] = useState(false);
  const [collectContactData, setCollectContactData] = useState([]);
  const [collectLoadData, setCollectLoadData] = useState({});
  const [collectLoadAvailabilityData, setCollectLoadAvailabilityData] =
    useState({});
  const [disableSenderName, setDisableSenderName] = useState(false);
  const [disableSenderStreetAddress, setDisableSenderStreetAddress] =
    useState(true);
  const [disableSenderSuburb, setDisableSenderSuburb] = useState(true);
  const [isToValidateSenderDocument, setIsToValidateSenderDocument] =
    useState(true);
  const [isToValidateRecipientDocument, setIsToValidateRecipientDocument] =
    useState(true);
  const [disableRecipientName, setDisableRecipientName] = useState(false);
  const [disableRecipientStreetAddress, setDisableRecipientStreetAddress] =
    useState(true);
  const [disableRecipientSuburb, setDisableRecipientSuburb] = useState(true);
  const [documentType, setDocumentType] = useState('');
  const [hasAcceptResponsibilityTerms, setHasAcceptResponsibilityTerms] =
    useState(false);
  const [addressList, setAddressList] = useState([]);
  const [selectedAddressIndex, setSelectedAddressIndex] = useState(0);
  const [isToValidateSenderAddressNumber, setIsToValidateSenderAddressNumber] =
    useState(true);
  const [addressRecipient, setAddressRecipient] = useState({});
  const [fileAmount, setFileAmount] = useState('');
  const [declarationFiles, setDeclarationFiles] = useState([]);
  const [invoiceFiles, setInvoiceFiles] = useState([]);
  const [invoiceNumberErrorList, setInvoiceNumberErrorList] = useState([]);
  const [invoiceDateErrorList, setInvoiceDateErrorList] = useState([]);
  const [otherFiles, setOtherFiles] = useState([]);
  const [removeDeclaration, setRemoveDeclaration] = useState('');
  const [removeInvoice, setRemoveInvoice] = useState('');
  const [removeFile, setRemoveFile] = useState('');
  const [acceptedInvoiceNotIssued, setAcceptedInvoiceNotIssued] =
    useState(false);
  const [receiveCollectInfoChecked, setReceiveCollectInfoChecked] = useState([
    false,
    false,
    true
  ]);
  const [receiveCollectInfoPhone, setReceiveCollectInfoPhone] = useState('');
  const [
    receiveCollectInfoPhoneConfirmation,
    setReceiveCollectInfoPhoneConfirmation
  ] = useState('');
  const [receiveCollectInfoEmail, setReceiveCollectInfoEmail] = useState('');
  const [
    receiveCollectInfoEmailConfirmation,
    setReceiveCollectInfoEmailConfirmation
  ] = useState('');
  const [protocolCollectCreated, setProtocolCollectCreated] = useState('');
  const [protocolCollectCanceled, setProtocolCollectCanceled] = useState('');
  const [hasCreatePickupWithInvoice, setHasCreatePickupWithInvoice] =
    useState(false);
  const [contactName, setContactName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [contactRamal, setContactRamal] = useState('');
  const [alternativeContactName, setAlternativeContactName] = useState('');
  const [alternativeContactEmail, setAlternativeContactEmail] = useState('');
  const [alternativeContactPhone, setAlternativeContactPhone] = useState('');
  const [alternativeContactExtension, setAlternativeContactExtension] =
    useState('');
  const [alternativeContactName2, setAlternativeContactName2] = useState('');
  const [alternativeContactEmail2, setAlternativeContactEmail2] = useState('');
  const [alternativeContactPhone2, setAlternativeContactPhone2] = useState('');
  const [searchList, setSearchList] = useState([]);
  const [alternativeContactExtension2, setAlternativeContactExtension2] =
    useState('');
  const [alternativeContact, setAlternativeContact] = useState(false);
  const [alternativeContact2, setAlternativeContact2] = useState(false);
  const [alternativeContactIsRequired, setAlternativeContactIsRequired] =
    useState(false);
  const [enableDeclaration, setEnableDeclaration] = useState(false);
  const [dataToAddCollectAddressModal, setDataToAddCollectAddressModal] =
    useState({});
  const [isPreCollect, setIsPreCollect] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { user, userAddressList } = useAuth();
  const { getBranchDetails } = useIntegration();
  const { GetAllFreightType, getPickupManagerParameterization } = useManager();
  const { openModal, closeModal, openedModal } = useModal();
  const {
    branchParameterizationId,
    createDefaultPickup,
    listUserLatestPickupAddress,
    setCustomerAcceptGuidelines
  } = usePickup();
  const { uploadFile } = useStorage();
  const {
    getWorkflowManagerParameterization,
    getWorkflowManagerGeneralWorkflowTypes
  } = useWorkflow();

  const history = useHistory();

  const maxSM = useMediaQuery('(max-width:768px)');
  const maxMD = useMediaQuery('(max-width:900px)');

  const onSubmit = async () => {
    try {
      if (!documentType) {
        toast(
          <Toast
            title="Atenção!"
            type="error"
            content="Selecione um tipo de documento fiscal."
          />,
          options
        );
        return;
      }

      // eslint-disable-next-line no-use-before-define
      openLoadingModal();

      let newRequesterCollectContactData = [];

      collectContactData.forEach((collectContact) => {
        newRequesterCollectContactData.push(collectContact);
        requester === 'sender' &&
          collectSenderData.contactList.push(collectContact);
      });

      collectRequesterData.contactList.forEach((contact) => {
        newRequesterCollectContactData.push(contact);
      });

      newRequesterCollectContactData = newRequesterCollectContactData.filter(
        (value) =>
          value.name && value.email && String(value.phoneNumber).length >= 10
      );

      collectSenderData.contactList = collectSenderData.contactList.filter(
        (value) =>
          value.name && value.email && String(value.phoneNumber).length >= 10
      );

      const requesterCorporation = {
        ...collectRequesterData,
        contactList: [...newRequesterCollectContactData]
      };

      const request = {
        pickup: {
          pickupNotification: {
            hasWhatsapp: receiveCollectInfoChecked[0],
            hasEmail: receiveCollectInfoChecked[2],
            hasSms: receiveCollectInfoChecked[1],
            phoneNumber: parsePhone(receiveCollectInfoPhone),
            emailAddress: receiveCollectInfoEmail
          },
          requesterCorporation,
          shipmentList: []
        }
      };

      let taxInformationType;

      if (documentType === 'declaration') {
        taxInformationType = 'Declaração';
      } else if (documentType === 'invoiceIssued') {
        taxInformationType = 'Nota Fiscal';
      } else if (documentType === 'invoiceNotIssued') {
        taxInformationType = 'Nota Fiscal a Emitir';
      }

      const taxInformation = {
        taxInvoiceAware: true,
        taxInformationType,
        taxQuantity: fileAmount,
        taxDocumentList: [],
        taxInvoiceList: []
      };

      if (documentType === 'declaration') {
        // eslint-disable-next-line no-restricted-syntax
        for await (const declarationFile of declarationFiles) {
          const storageUrl = await uploadFile({
            file: declarationFile.file
          });

          taxInformation.taxDocumentList.push({
            isAwareAccepted: true,
            isDeclaration: true,
            taxDocumentTypeId: 3,
            storageUrl
          });
        }
      }

      if (documentType === 'invoiceIssued') {
        // eslint-disable-next-line no-restricted-syntax
        for await (const invoiceFile of invoiceFiles) {
          const invoice = {
            number: invoiceFile.invoiceNumber,
            storageUrl: await uploadFile({
              file: invoiceFile.file
            })
          };

          if (invoiceFile.invoiceDate) {
            invoice.dateIssue = invoiceFile.invoiceDate;
          }

          taxInformation.taxInvoiceList.push(invoice);
        }
      }

      // eslint-disable-next-line no-restricted-syntax
      for await (const otherFile of otherFiles) {
        taxInformation.taxDocumentList.push({
          isAwareAccepted: true,
          isDeclaration: otherFile.documentType === '3',
          documentType: otherFile.documentType,
          taxDocumentTypeId: otherFile.documentType,
          storageUrl: await uploadFile({ file: otherFile.file })
        });
      }

      const branchDetailsParams = {
        zip_code: collectSenderData.address.zipPostalCode,
        transport_type: String(collectLoadData.modal) === '2' ? 'A' : 'R',
        sender_document: collectSenderData?.document
      };

      if (collectRecipientData?.document) {
        branchDetailsParams.receiver_document = parseCpfCnpj(
          collectRecipientData?.document
        );
      }

      const branchList = await getBranchDetails({
        params: branchDetailsParams
      });

      if (branchList?.length > 0) {
        request.pickup.branchSenderId = branchList[0]?.idFilial;
        request.pickup.idRoute = branchList[0]?.idRota;
        request.pickup.routeDescription = branchList[0]?.descricaoRota;
        request.pickup.colRouteDescription = branchList[0]?.colRotaDescricao;
      }

      let typeTransportId = '';

      if (String(collectLoadData.modal) === '1') {
        typeTransportId = 9;
      }
      if (String(collectLoadData.modal) === '2') {
        typeTransportId = 8;
      }

      let branchParameterization;

      const pickupManagerResponse = await getPickupManagerParameterization({
        branchId: branchList[0]?.idFilial,
        transportTypeId: typeTransportId,
        pickupTypeId: 1,
        inputTypeId: 5
      });

      if (pickupManagerResponse?.length > 0) {
        branchParameterization =
          pickupManagerResponse[0]?.branchParameterizationId;
      }

      if (!branchParameterization) {
        const defaultPickupManagerResponse =
          await getPickupManagerParameterization({
            branchId: 1,
            transportTypeId: 9,
            pickupTypeId: 1,
            inputTypeId: 5
          });

        if (defaultPickupManagerResponse?.length > 0) {
          branchParameterization =
            defaultPickupManagerResponse[0]?.branchParameterizationId;
        }
      }

      request.pickup.branchParameterizationId = branchParameterization;

      const workflowManagerResponse = await getWorkflowManagerParameterization({
        branchId: branchList[0]?.idFilial,
        transportTypeId: typeTransportId,
        pickupTypeId: 1,
        inputTypeId: 5
      });

      if (workflowManagerResponse?.length > 0) {
        request.pickup.branchWorkflowParameterizationId =
          workflowManagerResponse[0]?.branchParameterizationId;

        const workflowTypesResponse =
          await getWorkflowManagerGeneralWorkflowTypes({
            branchWorkflowParameterizationId:
              workflowManagerResponse[0]?.branchParameterizationId
          });

        if (workflowTypesResponse?.status === 200) {
          const { data: workflowTypes } = workflowTypesResponse?.data;

          if (workflowTypes?.length > 0) {
            const preCollection = workflowTypes.find(
              (value) => value.description === 'Pré-coleta'
            );

            if (preCollection) {
              preCollection?.enabled === true
                ? setIsPreCollect(true)
                : setIsPreCollect(false);
            }
          }
        }
      }

      if (workflowManagerResponse === undefined) {
        const workflowManagerResponseDefault =
          await getWorkflowManagerParameterization({
            branchId: 1,
            transportTypeId: 9,
            pickupTypeId: 1,
            inputTypeId: 5
          });

        if (workflowManagerResponseDefault?.length > 0) {
          request.pickup.branchWorkflowParameterizationId =
            workflowManagerResponseDefault[0]?.branchParameterizationId;

          const workflowTypesResponse =
            await getWorkflowManagerGeneralWorkflowTypes({
              branchWorkflowParameterizationId:
                workflowManagerResponseDefault[0]?.branchParameterizationId
            });

          if (workflowTypesResponse?.status === 200) {
            const { data: workflowTypes } = workflowTypesResponse?.data;

            if (workflowTypes?.length > 0) {
              const preCollection = workflowTypes.find(
                (value) => value.description === 'Pré-coleta'
              );

              if (preCollection) {
                preCollection?.enabled === true
                  ? setIsPreCollect(true)
                  : setIsPreCollect(false);
              }
            }
          }
        }
      }

      const shipmentAvailability = {
        pickupFromDate: collectLoadAvailabilityData.pickupFromDate,
        pickupUntilDate: collectLoadAvailabilityData.pickupUntilDate
      };

      request.pickup.shipmentList.push({
        transportTypeId: collectLoadData.modal,
        freightTypeId: collectLoadData.freight,
        senderCorporation: collectSenderData,
        receiverCorporation:
          requester === 'sender' ? collectRecipientData : requesterCorporation,
        shipmentAvailability,
        shipmentPackageList: [
          {
            measureTypeId: 0,
            materialTypeId: '0', // collectLoadData.material,
            materialDetail: '', // collectLoadData.MaterialDetail,
            volumeQuantity: collectLoadData.loadVolume,
            length: '0', // collectLoadData.loadLength
            //   .replaceAll('.', '')
            //   .replace(',', '.'),
            width: '0', // collectLoadData.loadWidth
            //   .replaceAll('.', '')
            //   .replace(',', '.'),
            height: '0', // collectLoadData.loadHeight
            //   .replaceAll('.', '')
            //   .replace(',', '.'),
            weight: collectLoadData.loadWeight
              .replaceAll('.', '')
              .replace(',', '.')
          }
        ],
        taxInformation
      });

      const protocol = await createDefaultPickup({ data: request });

      setProtocolCollectCreated(protocol);

      // eslint-disable-next-line no-use-before-define
      openCollectCreatedModal();
    } catch (error) {
      closeModal();
      // eslint-disable-next-line no-console
      console.log({ error });

      toast(
        <Toast
          title="Falha ao criar coleta."
          content="Tente novamente mais tarde."
          type="error"
        />,
        options
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const openInvoiceIssuedModal = () => {
    openModal('modalInvoiceIssued');
  };

  const openWishImportInvoiceModal = () => {
    openModal('modalWishImportInvoice');
  };

  const openPreCollectionModal = () => {
    openModal('modalPreCollection');
  };

  const openChangeCollectAddressModal = () => {
    openModal('modalChangeCollectAddress');
  };

  const openAddCollectAddressModal = () => {
    openModal('modalAddCollectAddress');
  };

  const openCreateDeclarationModal = () => {
    openModal('modalCreateDeclaration');
  };

  const openRemoveDeclarationModal = (id) => {
    openModal('modalRemoveDeclaration');
    setRemoveDeclaration(id);
  };

  const openRemoveInvoiceModal = (id) => {
    openModal('modalRemoveInvoice');
    setRemoveInvoice(id);
  };

  const openRemoveFileModal = (id) => {
    openModal('modalRemoveFile');
    setRemoveFile(id);
  };

  const openAcceptInvoiceNotIssuedModal = () => {
    openModal('modalAcceptInvoiceNotIssued');
  };

  const openAcceptTransportTermsModal = () => {
    openModal('modalAcceptTransportTerms');
  };

  const openReceiveCollectInfoModal = () => {
    openModal('modalReceiveCollectInfo');
  };

  const openAcceptResponsibilityTermsModal = () => {
    openModal('modalAcceptResponsibilityTerms');
  };

  const createDeclarationPdf = ({
    senderData,
    recipientData,
    commodityList
  }) => {
    pdfMake
      .createPdf(
        contentDeclaration({ senderData, recipientData, commodityList })
      )
      .getBlob((blob) => {
        const id = uuid();

        const generatedDeclaration = new File([blob], `declaracao-${id}.pdf`, {
          type: blob.type
        });

        const newDeclarationFiles = [...declarationFiles];

        newDeclarationFiles.push({
          id,
          file: generatedDeclaration,
          name: generatedDeclaration.name,
          size: generatedDeclaration.size,
          readableSize: fileSize(generatedDeclaration.size),
          senderData,
          recipientData,
          commodityList
        });

        setDeclarationFiles(newDeclarationFiles);
      });
  };

  const openLoadingModal = () => {
    openModal('modalLoading');
  };

  const openCollectCreatedModal = () => {
    openModal('modalCollectCreated');
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleBackStep = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNextStep = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleSetStep = (step) => {
    setActiveStep(step);
  };

  const useForceUpdate = () => {
    const [value, setState] = useState(true);
    return () => setState(!value);
  };

  // const handleResetCollect = () => {
  //   setTransportTypeList([]);
  //   setTransportSelectedToModal('');
  //   setFreightTypeList([]);
  //   setMaterialTypeList([]);
  //   setOtherMaterialId('');
  //   setCheckListSelected({});
  //   setRequester('');
  //   setRequesterContact({
  //     contactName: '',
  //     contactEmail: '',
  //     phoneNumber: '',
  //     extension: ''
  //   });
  //   setHasVariousDestinations(false);
  //   setDestinationQuantity('');
  //   setCollectRequesterData({});
  //   setCollectSenderData({});
  //   setCollectRecipientData({});
  //   setDisabledRecipientData(false);
  //   setCollectContactData([]);
  //   setCollectLoadData({});
  //   setCollectLoadAvailabilityData({});
  //   setDisableSenderName(false);
  //   setDisableRecipientStreetAddress(true);
  //   setDisableRecipientSuburb(true);
  //   setDocumentType('');
  //   setHasAcceptResponsibilityTerms(false);
  //   setAddressList([]);
  //   setSelectedAddressIndex(0);
  //   setAddressRecipient({});
  //   setFileAmount('');
  //   setDeclarationFiles([]);
  //   setInvoiceFiles([]);
  //   setInvoiceNumberErrorList([]);
  //   setInvoiceDateErrorList([]);
  //   setOtherFiles([]);
  //   setRemoveDeclaration('');
  //   setRemoveInvoice('');
  //   setRemoveFile('');
  //   setAcceptedInvoiceNotIssued(false);
  //   setCustomerAcceptGuidelines(false);
  //   setReceiveCollectInfoChecked([false, false, true]);
  //   setReceiveCollectInfoPhone('');
  //   setReceiveCollectInfoPhoneConfirmation('');
  //   setReceiveCollectInfoEmail('');
  //   setReceiveCollectInfoEmailConfirmation('');
  //   setProtocolCollectCreated('');
  //   setContactName('');
  //   setContactEmail('');
  //   setPhoneNumber('');
  //   setContactRamal('');
  //   setAlternativeContactName('');
  //   setAlternativeContactEmail('');
  //   setAlternativeContactPhone('');
  //   setAlternativeContactExtension('');
  //   setAlternativeContactName2('');
  //   setAlternativeContactEmail2('');
  //   setAlternativeContactPhone2('');
  //   setAlternativeContactExtension2('');
  //   setAlternativeContact(false);
  //   setAlternativeContact2(false);
  //   setIsPreCollect(false);
  //   setHasCreatePickupWithInvoice(false);
  //   handleSetStep(0);
  //   // eslint-disable-next-line no-use-before-define
  //   onComponentDidMount();
  // };

  const onComponentDidMount = async () => {
    if (!branchParameterizationId) {
      history.push('/acesso-rapido/tipo-de-coleta');
      return;
    }

    openLoadingModal();

    const requesterType = localStorage.getItem('@Braspress:requesterType');

    if (requesterType) {
      setRequester(requesterType);

      if (requesterType === 'sender') {
        setSteps([
          'Dados do Solicitante',
          'Dados da Coleta',
          'Dados da Carga',
          'Informações Fiscais'
        ]);
      } else if (requesterType === 'recipient') {
        setSteps([
          'Dados do Solicitante',
          'Dados da Coleta',
          'Dados da Carga',
          'Informações Fiscais'
        ]);
      }
    }

    let newUserAddressList = [];

    if (userAddressList?.length > 0) {
      newUserAddressList = userAddressList.map((value) => {
        if (!value.name) {
          value.name = user?.name || '';
        }

        if (!value.document) {
          value.document = user?.document || '';
        }

        if (!value.contactEmail) {
          value.contactEmail = userAddressList[0]?.email || user.email || '';
        }

        if (!value.contactExtension) {
          value.contactExtension = userAddressList[0]?.contactExtension || '';
        }

        if (!value.contactName) {
          value.contactName = userAddressList[0]?.contact || user?.name || '';
        }

        if (!value.contactNumber) {
          value.contactNumber = userAddressList[0]?.telephone
            ? String(userAddressList[0]?.telephone || '').padStart(10, '0')
            : '';
        }

        if (value.userId) {
          delete value.userId;
        }

        if (value.userAddressId) {
          delete value.userAddressId;
        }

        return value;
      });
    }

    setAddressList(newUserAddressList);

    const freightList = await GetAllFreightType();
    setFreightTypeList(freightList);

    const latestPickupAddressList = await listUserLatestPickupAddress();

    if (latestPickupAddressList) {
      const { pickupAddressList, pickupContactList } = latestPickupAddressList;

      const newLatestPickupAddressList = pickupAddressList.map((address) => {
        return {
          additionalInformation: address.additionalInformation,
          city: address.city,
          contactName: address.contactName,
          contactEmail: address.email,
          contactExtension: address.extension,
          contactNumber: address.phoneNumber,
          country: address.country,
          document: address.document,
          name: address.senderName,
          state: address.state,
          streetAddress: address.streetAddress,
          streetAddressNumber: address.streetNumber,
          suburb: address.suburb,
          zipPostalCode: address.zipPostalCode
        };
      });

      if (newLatestPickupAddressList?.length > 0) {
        newUserAddressList = [
          ...userAddressList,
          ...newLatestPickupAddressList
        ];

        newUserAddressList = newUserAddressList?.filter(
          (value, index, self) =>
            index ===
            self?.findIndex((compareValue) => {
              if (!compareValue.additionalInformation) {
                compareValue.additionalInformation = '';
              }

              if (!value.additionalInformation) {
                value.additionalInformation = '';
              }

              return (
                compareValue.name?.toLowerCase() ===
                  value.name?.toLowerCase() &&
                compareValue.document === value.document &&
                compareValue.additionalInformation?.toLowerCase() ===
                  value.additionalInformation?.toLowerCase() &&
                compareValue.city?.toLowerCase() ===
                  value.city?.toLowerCase() &&
                compareValue.state?.toLowerCase() ===
                  value.state?.toLowerCase() &&
                compareValue.streetAddress?.toLowerCase() ===
                  value.streetAddress?.toLowerCase() &&
                compareValue.streetAddressNumber?.toLowerCase() ===
                  value.streetAddressNumber?.toLowerCase() &&
                compareValue.suburb?.toLowerCase() ===
                  value.suburb?.toLowerCase() &&
                compareValue.zipPostalCode === value.zipPostalCode &&
                compareValue.contactEmail?.toLowerCase() ===
                  value.contactEmail?.toLowerCase() &&
                compareValue.contactExtension?.toLowerCase() ===
                  value.contactExtension?.toLowerCase() &&
                compareValue.contactName?.toLowerCase() ===
                  value.contactName?.toLowerCase() &&
                compareValue.contactNumber?.toLowerCase() ===
                  value.contactNumber?.toLowerCase()
              );
            })
        );

        const newParsedUserAddressList = newUserAddressList?.map((value) => {
          value.zipPostalCode = parsePhone(value.zipPostalCode);
          value.contactNumber = parsePhone(value.contactNumber);

          return value;
        });

        setAddressList(newParsedUserAddressList);

        const contact = {};

        if (pickupContactList?.length > 0) {
          if (pickupContactList[0]?.contactName) {
            contact.contactName = pickupContactList[0].contactName;
          }
          if (pickupContactList[0]?.email) {
            contact.contactEmail = pickupContactList[0].email;
          }
          if (pickupContactList[0]?.phoneNumber) {
            contact.phoneNumber = String(
              pickupContactList[0]?.phoneNumber
            ).padStart(10, '0');
          }
          if (pickupContactList[0]?.extension) {
            contact.extension = pickupContactList[0].extension;
          }
        }

        setRequesterContact(contact);
      }
    }

    if (requesterType === 'sender') {
      openInvoiceIssuedModal();
    } else {
      closeModal();
    }
  };

  useEffect(() => {
    onComponentDidMount();
  }, []);

  useEffect(() => {
    isSubmitting && onSubmit();
  }, [isSubmitting]);

  const contextValues = {
    steps,
    setSteps,
    activeStep,
    handleBackStep,
    handleNextStep,
    // handleResetCollect,
    requester,
    setRequester,
    hasVariousDestinations,
    setHasVariousDestinations,
    destinationQuantity,
    setDestinationQuantity,
    requesterContact,
    collectRequesterData,
    setCollectRequesterData,
    collectSenderData,
    setCollectSenderData,
    collectRecipientData,
    setCollectRecipientData,
    disabledRecipientData,
    setDisabledRecipientData,
    collectContactData,
    setCollectContactData,
    hasAcceptResponsibilityTerms,
    setHasAcceptResponsibilityTerms,
    collectLoadData,
    setCollectLoadData,
    collectLoadAvailabilityData,
    setCollectLoadAvailabilityData,
    disableSenderName,
    setDisableSenderName,
    disableSenderStreetAddress,
    setDisableSenderStreetAddress,
    disableSenderSuburb,
    setDisableSenderSuburb,
    isToValidateSenderDocument,
    setIsToValidateSenderDocument,
    isToValidateRecipientDocument,
    setIsToValidateRecipientDocument,
    disableRecipientName,
    setDisableRecipientName,
    disableRecipientStreetAddress,
    setDisableRecipientStreetAddress,
    disableRecipientSuburb,
    setDisableRecipientSuburb,
    transportTypeList,
    setTransportTypeList,
    transportSelectedToModal,
    setTransportSelectedToModal,
    freightTypeList,
    materialTypeList,
    setMaterialTypeList,
    otherMaterialId,
    setOtherMaterialId,
    checkListSelected,
    setCheckListSelected,
    openInvoiceIssuedModal,
    openWishImportInvoiceModal,
    openPreCollectionModal,
    openChangeCollectAddressModal,
    openAddCollectAddressModal,
    openCreateDeclarationModal,
    openRemoveDeclarationModal,
    openRemoveInvoiceModal,
    openRemoveFileModal,
    openAcceptInvoiceNotIssuedModal,
    openAcceptTransportTermsModal,
    openReceiveCollectInfoModal,
    openAcceptResponsibilityTermsModal,
    openLoadingModal,
    createDeclarationPdf,
    fileAmount,
    setFileAmount,
    documentType,
    setDocumentType,
    declarationFiles,
    setDeclarationFiles,
    invoiceFiles,
    setInvoiceFiles,
    invoiceNumberErrorList,
    setInvoiceNumberErrorList,
    invoiceDateErrorList,
    setInvoiceDateErrorList,
    otherFiles,
    setOtherFiles,
    addressList,
    setAddressList,
    selectedAddressIndex,
    setSelectedAddressIndex,
    isToValidateSenderAddressNumber,
    setIsToValidateSenderAddressNumber,
    removeDeclaration,
    setRemoveDeclaration,
    removeInvoice,
    setRemoveInvoice,
    removeFile,
    setRemoveFile,
    acceptedInvoiceNotIssued,
    setAcceptedInvoiceNotIssued,
    receiveCollectInfoChecked,
    setReceiveCollectInfoChecked,
    receiveCollectInfoPhone,
    setReceiveCollectInfoPhone,
    receiveCollectInfoPhoneConfirmation,
    setReceiveCollectInfoPhoneConfirmation,
    receiveCollectInfoEmail,
    setReceiveCollectInfoEmail,
    receiveCollectInfoEmailConfirmation,
    setReceiveCollectInfoEmailConfirmation,
    addressRecipient,
    setAddressRecipient,
    protocolCollectCreated,
    protocolCollectCanceled,
    setProtocolCollectCanceled,
    useForceUpdate,
    hasCreatePickupWithInvoice,
    setHasCreatePickupWithInvoice,
    isSubmitting,
    setIsSubmitting,
    contactName,
    setContactName,
    contactEmail,
    setContactEmail,
    phoneNumber,
    setPhoneNumber,
    contactRamal,
    setContactRamal,
    alternativeContactName,
    setAlternativeContactName,
    alternativeContactEmail,
    setAlternativeContactEmail,
    alternativeContactPhone,
    setAlternativeContactPhone,
    alternativeContactExtension,
    setAlternativeContactExtension,
    alternativeContactName2,
    setAlternativeContactName2,
    alternativeContactEmail2,
    setAlternativeContactEmail2,
    alternativeContactPhone2,
    setAlternativeContactPhone2,
    alternativeContactExtension2,
    setAlternativeContactExtension2,
    alternativeContact,
    setAlternativeContact,
    alternativeContact2,
    setAlternativeContact2,
    enableDeclaration,
    setEnableDeclaration,
    dataToAddCollectAddressModal,
    setDataToAddCollectAddressModal,
    isPreCollect
  };

  return (
    <DefaultCollectContext.Provider value={contextValues}>
      <Container>
        {/* <Header /> */}
        <Content>
          <Box margin="0 40px" paddingBottom="40px">
            {/* <Route>
              {!maxSM && (
                <>
                  Home {'>'} Acesso Rápido {'>'} Pedido de Coleta
                </>
              )}

              {!!user && (
                <Stack
                  direction="row"
                  spacing={2}
                  style={{
                    alignItems: 'center',
                    marginLeft: maxSM && 'auto'
                  }}
                >
                  <p>{user.name}</p>
                  <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    onClick={signOut}
                    size="small"
                  >
                    Sair
                  </Button>
                </Stack>
              )}
            </Route> */}

            <TitlePage>
              PEDIDO DE COLETA PADRÃO
              <span style={{ marginTop: 15 }}>
                Visando otimizar a emissão dos conhecimentos de embarque
                pedimos, por gentileza, anexar os arquivos XML
                <br /> das notas fiscais transportadas pela Braspress, na
                solicitação de coleta ou encaminhe para o e-mail:
                <br />
                <a href={`mailto:${'ti.nfe@braspress.com'}`}>
                  ti.nfe@braspress.com
                </a>
              </span>
              <hr />
              <span>Preencha corretamente os campos abaixo</span>
            </TitlePage>

            <Paper elevation={2} style={{ marginTop: 16, padding: '16px' }}>
              <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};

                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }

                  return (
                    <Step key={label} {...stepProps}>
                      {maxMD ? (
                        <StepLabel {...labelProps} />
                      ) : (
                        <StepLabel {...labelProps}>{label}</StepLabel>
                      )}
                    </Step>
                  );
                })}
              </Stepper>
            </Paper>

            {activeStep === 0 && <RequesterData />}
            {activeStep === 1 && <CollectData />}
            {activeStep === 2 && <LoadData />}
            {activeStep === 3 && <TaxInfo />}
          </Box>
        </Content>
      </Container>

      {openedModal === 'modalPreCollection' && <ModalPreCollection />}
      {openedModal === 'modalInvoiceIssued' && <ModalInvoiceIssued />}
      {openedModal === 'modalWishImportInvoice' && <ModalWishImportInvoice />}
      {openedModal === 'modalChangeCollectAddress' && (
        <ModalChangeCollectAddress />
      )}
      {openedModal === 'modalAddCollectAddress' && <ModalAddCollectAddress />}
      {openedModal === 'modalAcceptTransportTerms' && (
        <ModalAcceptTransportTerms />
      )}
      {openedModal === 'modalReceiveCollectInfo' && <ModalReceiveCollectInfo />}
      {openedModal === 'modalCreateDeclaration' && <ModalCreateDeclaration />}
      {openedModal === 'modalRemoveDeclaration' && <ModalRemoveDeclaration />}
      {openedModal === 'modalRemoveInvoice' && <ModalRemoveInvoice />}
      {openedModal === 'modalRemoveFile' && <ModalRemoveFile />}
      {openedModal === 'modalAcceptInvoiceNotIssued' && (
        <ModalAcceptInvoiceNotIssued />
      )}
      {openedModal === 'modalAcceptResponsibilityTerms' && (
        <ModalAcceptResponsibilityTerms />
      )}
      {openedModal === 'modalLoading' && <ModalLoading />}
      {openedModal === 'modalCollectCreated' && <ModalCollectCreated />}
      {openedModal === 'modalFinancialRestriction' && (
        <ModalFinancialRestriction />
      )}
    </DefaultCollectContext.Provider>
  );
};

export default DefaultCollect;
